import { DateTime } from 'luxon';

/**
 * Retuns an array of dates prior to the month supplied that complete the week leading up the first of the month (e.g. Sunday to the last day of the previous month)
 * @param monthStart First of the month of interest, e.g. Wed 1/1
 * @returns DateTime array, e.g. Sun 12/29, Mon 12/30, Tue 12/31
 */
export function calendarWeekPrior(monthStart: DateTime): DateTime[] {
  const days = [];
  let dt = monthStart.minus({ days: 1 });
  while (dt.weekday !== 6) { // Add dates until we reach Saturday (previous row)
    days.unshift(dt);
    dt = dt.minus({ days: 1 });
  }

  return days;
}

/**
 * Retuns an array of dates after the end of the month supplied that complete the week following the last of the month (e.g. first of the following month to Saturday)
 * @param monthStart First of the month of interest, e.g. Thu 2/1
 * @returns DateTime array, e.g. Thu 3/1, Fri 3/2, Sat 3/3
 */
export function calendarWeekFollowing(monthStart: DateTime): DateTime[] {
  const days = [];
  let dt = monthStart.plus({ months: 1 });
  while (dt.weekday !== 7) { // Add dates until we reach Sunday (next row)
    days.push(dt);
    dt = dt.plus({ days: 1 });
  }

  return days;
}
